module.exports = __webpack_public_path__ + "public/Icons/cancelled_bookings.svg?bb4ce106";